import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import DownloadSection from './components/DownloadSection';
import FeatureSection from './components/FeatureSection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="黄油下载 - 官方安全下载黄油相机App | 最新版免费下载"
        description="黄油下载专区，提供黄油相机App最新版官方安全下载。黄油相机是一款专业文字与滤镜美化工具，支持iOS与Android设备，一键下载即可体验海量字体、滤镜与模板。"
        keywords="黄油下载,黄油相机下载,黄油相机最新版下载,黄油相机安卓下载,黄油相机iOS下载,黄油相机官方下载,黄油相机免费下载"
      />

      <SchemaOrg
        type="Organization"
        data={{
          name: '黄油下载',
          url: 'https://huangyouxiazai.com',
          description: '黄油相机官方安全下载平台',
        }}
      />

      <SchemaOrg
        type="WebSite"
        data={{
          name: '黄油下载',
          url: 'https://huangyouxiazai.com',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://huangyouxiazai.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />

      <SchemaOrg
        type="WebPage"
        data={{
          name: '黄油下载 - 首页',
          url: 'https://huangyouxiazai.com',
          description: '黄油相机官方安全下载平台首页',
        }}
      />

      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            {
              '@type': 'Question',
              name: '黄油相机是免费的吗？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '黄油相机提供免费版本，包含大部分基础功能。同时也有会员版本，解锁全部字体、高级滤镜、专属模板等。',
              },
            },
            {
              '@type': 'Question',
              name: '黄油相机支持哪些设备？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '黄油相机支持iOS和Android两大平台。iOS要求iOS 13.0及以上，Android要求Android 6.0及以上。',
              },
            },
            {
              '@type': 'Question',
              name: '如何确保下载的是正版黄油相机？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'iOS用户请在App Store搜索，Android用户请在手机自带应用商店搜索，认准开发者为北京缪客科技有限公司。',
              },
            },
            {
              '@type': 'Question',
              name: '黄油相机8.0版本有哪些新功能？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '新增AI智能排版引擎、一键去水印、批量处理、新增20款字体和15款滤镜、性能优化提升30%。',
              },
            },
          ],
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <DownloadSection />
          <FeatureSection />
          <ArticleSection />
          <FAQSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}